// Static make/model dataset for the Mașini "Adaugă/Editează" dropdowns.
// A live external API (NHTSA vpic.nhtsa.gov) was tried first but turned out
// to be unreachable from every environment tested here (browser, this
// backend server, and the tool sandbox this was built in all failed DNS
// resolution to it) — so this ships as a bundled list instead. It's not
// exhaustive, just the makes/models common on European roads; both fields
// stay freeSolo in CarModal, so anything not listed can still be typed
// directly.
const CAR_MAKES_MODELS = {
  'Dacia': ['Logan', 'Sandero', 'Duster', 'Spring', 'Jogger', 'Dokker'],
  'Renault': ['Clio', 'Megane', 'Captur', 'Kadjar', 'Talisman', 'Scenic', 'Kangoo', 'Trafic', 'Master'],
  'Volkswagen': ['Golf', 'Polo', 'Passat', 'Tiguan', 'Touran', 'T-Roc', 'T-Cross', 'Caddy', 'Transporter', 'Jetta'],
  'Ford': ['Fiesta', 'Focus', 'Kuga', 'Mondeo', 'Puma', 'EcoSport', 'Transit', 'Transit Connect', 'Galaxy'],
  'Opel': ['Corsa', 'Astra', 'Insignia', 'Crossland', 'Grandland', 'Mokka', 'Combo', 'Vivaro', 'Zafira'],
  'Skoda': ['Fabia', 'Octavia', 'Superb', 'Kamiq', 'Karoq', 'Kodiaq', 'Scala', 'Rapid'],
  'Toyota': ['Yaris', 'Corolla', 'Auris', 'C-HR', 'RAV4', 'Avensis', 'Aygo', 'Hilux', 'Proace'],
  'Hyundai': ['i10', 'i20', 'i30', 'Tucson', 'Kona', 'Santa Fe', 'Elantra', 'Bayon'],
  'Kia': ['Picanto', 'Rio', 'Ceed', 'Sportage', 'Sorento', 'Stonic', 'Niro', 'Soul'],
  'Peugeot': ['208', '308', '2008', '3008', '5008', 'Partner', 'Expert', 'Boxer', '508'],
  'Citroën': ['C3', 'C4', 'C5 Aircross', 'Berlingo', 'Jumpy', 'Jumper', 'C1'],
  'Fiat': ['Panda', 'Punto', 'Tipo', '500', '500X', 'Doblo', 'Ducato', 'Talento'],
  'Seat': ['Ibiza', 'Leon', 'Arona', 'Ateca', 'Tarraco', 'Alhambra'],
  'BMW': ['Seria 1', 'Seria 2', 'Seria 3', 'Seria 5', 'X1', 'X3', 'X5', 'X2'],
  'Mercedes-Benz': ['Clasa A', 'Clasa B', 'Clasa C', 'Clasa E', 'GLA', 'GLC', 'Vito', 'Sprinter'],
  'Audi': ['A1', 'A3', 'A4', 'A6', 'Q2', 'Q3', 'Q5'],
  'Nissan': ['Micra', 'Note', 'Qashqai', 'Juke', 'X-Trail', 'Navara', 'NV200'],
  'Honda': ['Civic', 'CR-V', 'Jazz', 'HR-V', 'Accord'],
  'Mazda': ['Mazda2', 'Mazda3', 'Mazda6', 'CX-3', 'CX-5', 'CX-30'],
  'Suzuki': ['Swift', 'Vitara', 'S-Cross', 'Ignis', 'Jimny'],
  'Volvo': ['V40', 'V60', 'S60', 'XC40', 'XC60', 'XC90'],
  'Chevrolet': ['Aveo', 'Cruze', 'Spark', 'Captiva'],
  'Mitsubishi': ['Space Star', 'ASX', 'Outlander', 'L200'],
  'Jeep': ['Renegade', 'Compass', 'Cherokee', 'Wrangler'],
  'Land Rover': ['Discovery Sport', 'Range Rover Evoque', 'Defender', 'Freelander'],
  'Mini': ['Cooper', 'Countryman', 'Clubman'],
  'Smart': ['Fortwo', 'Forfour'],
  'Alfa Romeo': ['Giulietta', 'Giulia', 'Stelvio', 'MiTo'],
  'Subaru': ['Impreza', 'Forester', 'XV', 'Outback'],
  'Lexus': ['CT', 'IS', 'NX', 'RX'],
  'Porsche': ['911', 'Cayenne', 'Macan', 'Panamera'],
  'Jaguar': ['XE', 'XF', 'E-Pace', 'F-Pace'],
  'Tesla': ['Model 3', 'Model S', 'Model X', 'Model Y'],
  'Cupra': ['Leon', 'Formentor', 'Ateca'],
  'MG': ['ZS', 'HS', 'MG3', 'MG5'],
  'Iveco': ['Daily'],
  'Isuzu': ['D-Max'],
};

export const CAR_MAKES = Object.keys(CAR_MAKES_MODELS).sort();

export function modelsForMake(make) {
  return CAR_MAKES_MODELS[make] || [];
}
